export const blockIconsNotificationNetworkCheck = (
	<span className='material-symbols-outlined'>network_check</span>
);
